<template>
    <div class="w3-container w3-responsive">
      <div class="w3-card" style="max-width: 100%; margin: 0">
        <header class="w3-container w3-green">
          <h2>佣金比例说明</h2>
        </header>
      </div>
        <div class="w3-container w3-padding-16 w3-text-grey">
         <div class="w3-flex" style="justify-content: space-between">
            <h6>下线用户游戏结算后，盈利的部分，有 3% 的抽水，再按佣金比例分配给代理。</h6>
          </div>   
          <div class="w3-flex" style="justify-content: space-between">
            <h6>例子：如果下线用户游戏盈利 100，代理佣金比例是 50%，那么代理将获得 1.5的佣金。</h6>
          </div>         
      </div>
    </div>
  </template>
  
  <script>

  </script>
  
  <style scoped>
  .w3-image {
    display: block;
    margin: 0 auto;
    padding: 20px;
    background: white;
    border: 1px solid #ddd;
  }
  </style>